// Core
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';

// Chakra imports
import { Box } from '@chakra-ui/react';

// Components
import ExternalPrice from './ExternalPrice';
import usePermissionStatusByKey from '../../../hooks/usePermissionStatusByKey';

function ExternalPrices(props) {
  const { path } = useRouteMatch();

  const isExternalPrices = usePermissionStatusByKey(
    'GET:/admin/external-prices',
  );

  return (
    <>
      <Box>
        <Switch>
          {isExternalPrices && (
            <Route path={`${path}`} render={() => <ExternalPrice />} />
          )}
          <Redirect from={`${path}*`} to={`${path}`} />
        </Switch>
      </Box>
    </>
  );
}

export default ExternalPrices;
